// Placeholder copy from the approved wireframes; the hi-fi screens may still change it.
export const mailboxCopy = {
  title: 'Email',
  optionalBadge: 'Optional',
  description: 'Send emails and create drafts from your inbox when a Flow asks for it.',
  missingScopesDescription:
    'Chili Piper needs new email permissions. Connect again to keep Flows sending from your inbox.',
  /** Onboarding step CTA; the Integrations page uses the plain `connect` / `disconnect`. */
  allow: 'Allow email sending',
  connect: 'Connect',
  connecting: 'Connecting...',
  disconnect: 'Disconnect',
  disconnecting: 'Disconnecting...',
  allowedToast: 'Email sending allowed',
  disconnectDialog: {
    title: 'Disconnect email?',
    description:
      'Flows will stop sending emails from your inbox right away. Your calendar stays connected, so meetings keep working.',
  },
} as const
